import { POST } from "../../index";

export const queryCarData = (param) => POST("/v1/HomePage/selectByCarRealTimeStatusOnOrgId", param);
export const queryCarDataCount = (param) => POST("/v1/HomePage/selectTerminalDataCount", param);
export const queryViolationCount = (param) => POST("/v1/HomePage/selectSumViolation", param);
export const queryProblemCount = (param) => POST("/v1/HomePage/selectProblemCount", param);
export const queryCarDataList = (param) => POST("/v1/HomePage/selectCarStatisticsList", param);
export const queryDriverDataList = (param) => POST("/v1/HomePage/DriverWorkingHoursStatistics", param);
export const selectUserLocation = (param) => POST("/v1/HomePage/selectUserLocation", param);

export const getStatisticalData = (param) => POST("/v1/carSynthesize/getStatisticalData", param);
export const getCarAgeProportion = (param) => POST("/v1/carSynthesize/getCarAgeProportion", param);
export const getCarCapacityProportion = (param) => POST("/v1/carSynthesize/getCarCapacityProportion", param);
export const getCarWorkRate = (param) => POST("/v1/carSynthesize/getCarWorkRate", param);
export const getCarSpotCheckRate = (param) => POST("/v1/carSynthesize/getCarSpotCheckRate", param);
export const getCarDistributionState = (param) => POST("/v1/carSynthesize/getCarDistributionState", param);
